import { forEach } from 'lodash';

/** @typedef {{ [key: string]: any } | any[]} Collection */
/** @typedef {{ key: string, value: any }[]} Stack */

/**
 * @callback ForEachDeepCallback
 * @param {any} value
 * @param {string} key
 * @param {Collection} parent
 * @param {string} path
 */

/**
 * @param {Collection} collection
 * @param {ForEachDeepCallback} iteratree
 * @param {Stack} stack
 */
function baseForEachDeep(collection, iteratree, stack) {
    forEach(collection, (value, key) => {
        stack.push({ key, value });
        iteratree(value, key, collection, stackToPath(stack));

        if (value && typeof value === 'object') {
            baseForEachDeep(value, iteratree, stack);
        }

        stack.pop();
    });
}

/**
 * @param {Stack} stack
 */
function stackToPath(stack) {
    return stack
        .map(({ key }, index) => (
            typeof key === 'string' ? `${index > 0 ? '.' : ''}${key}`
            : `[${key}]`
        ))
        .join('');
}

/**
 * @param {Collection} collection
 * @param {ForEachDeepCallback} iteratree
 */
export default function forEachDeep(collection, iteratree) {
    const stack = [];

    baseForEachDeep(collection, iteratree, stack, null);
}